// @ts-ignore
window.dataLayer = window.dataLayer || []
// @ts-ignore
function gtag () { dataLayer.push(arguments) }

export { gtag }
